// @flow
import * as React from 'react';
import {Text} from 'sail/Text';
import Box from 'sail/Box';
import Group from 'sail/Group';
import {Card} from '../../core/Cards/framework';

type PartnerPerkProps = {|
  title: string,
  subtitle: string,
  icon: string,
  children: React.Node,
|};

export const PartnerPerk = ({
  title,
  subtitle,
  icon,
  children,
}: PartnerPerkProps) => {
  return (
    <Card bordered>
      <Group direction="horizontal" spacing={12}>
        <Box margin={{right: 12, top: 2}} style={{maxHeight: '40px'}}>
          <img alt="" src={icon} />
        </Box>
        <Group spacing={8}>
          <Text color="dark" weight="medium" size={20}>
            {title}
          </Text>
          <Text color="dark" weight="medium" size={15}>
            {subtitle}
          </Text>

          {children}
        </Group>
      </Group>
    </Card>
  );
};
